import { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Divider, Message, Modal, useToaster } from "rsuite";
import { appCRUD } from "../../../../../actions/app";
import Webcam from "react-webcam";
import "./photo.css";

export const PhotoAdd = (props) => {
  const { open, setOpen, studentId } = props;
  const webcamRef = useRef(null);
  const [photo, setPhoto] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [error, setError] = useState(null);
  const [cameraReady, setCameraReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const sigCanvas = useRef(null);
  const toaster = useToaster();

  // Ask permission when component loads
  useEffect(() => {
    if (open) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(() => setCameraReady(true))
        .catch(() => setError("Please allow camera permission"));
    }
  }, [open]);

  

  // Auto-center crop function
  const cropToFrame = (base64, x, y, w, h) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, x, y, w, h, 0, 0, w, h);

        resolve(canvas.toDataURL("image/jpeg"));
      };
    });
  };

  const getImageSize = (base64) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64;
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
    });
  };

  // Capture photo
 const capture = async (webcamRef, setPhoto) => {
   if (!webcamRef.current) return;

   // Take screenshot
   const imageSrc = webcamRef.current.getScreenshot();
   if (!imageSrc) return;

   // Get screenshot dimensions
   const { width: imgWidth, height: imgHeight } = await getImageSize(imageSrc);

   // Define crop size relative to screenshot
   // e.g., 50% width and 70% height for face area
   const cropW = imgWidth * 0.5;
   const cropH = imgHeight * 0.7;

   // Center crop
   const cropX = (imgWidth - cropW) / 2;
   const cropY = (imgHeight - cropH) / 2;

   // Crop image
   const croppedImage = await cropToFrame(imageSrc, cropX, cropY, cropW, cropH);

   // Set cropped photo
   setPhoto(croppedImage);
 };

  const increaseZoom = () => setZoom((z) => Math.min(z + 0.1, 2));
  const decreaseZoom = () => setZoom((z) => Math.max(z - 0.1, 1));

  const handleClear = () => {
    sigCanvas.current?.clear();
    setPhoto(null);
    setError(null);
  };

  const clearPhoto = (setPhoto) => {
    setPhoto(null);
  };

  // 💾 Save both
  const handleSave = () => {
    if (!photo) {
      setError("Please capture a photo first.");
      return;
    }

    const dataToSend = {
      photo: photo,
    };

    setLoading(true);
    setTimeout(() => {
      appCRUD
        .patchStudentData(studentId, dataToSend)
        .then(() => {
          toaster.push(
            <Message type="success" showIcon header="Success" closable>
              <p className="fw-bold fs-14">
                Signature and Photo Added Successfully
              </p>
            </Message>,
            { placement: "topEnd", duration: 7000 }
          );
          setOpen(false);
          handleClear();
          window.location.reload();
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }, 1000);
  };
  return (
    <>
      {loading && (
        <div className="preloader">
          <div className="loader">
            <div className="circle"></div>
            <span className="loader-text">Please Wait</span>
          </div>
        </div>
      )}
      <Modal open={open} onClose={() => setOpen(false)} size="md">
        <Modal.Header>
          <Modal.Title>Capture Photo & Signature</Modal.Title>
        </Modal.Header>
        <Divider />

        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              {/* Webcam Section */}
              <div className="col-12 mb-3 text-center">
                {!photo ? (
                  <>
                    <div className="webcam-container">
                      {cameraReady ? (
                        <div className="camera-box">
                          {/* <Webcam
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            videoConstraints={{ facingMode: "user" }}
                            className="webcam-view"
                            style={{
                              transform: `scale(${zoom})`,
                              transition: "0.2s ease",
                            }}
                          /> */}
                          <Webcam
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            videoConstraints={{
                              facingMode: { ideal: "environment" },
                            }}
                            className="webcam-view"
                            style={{
                              transform: `scale(${zoom})`,
                              transition: "0.2s ease",
                            }}
                          />

                          {/* Crop Frame */}
                          <div className="crop-frame" />

                          {/* Zoom controls */}
                          {/* <div className="zoom-controls">
                            <button onClick={increaseZoom}>+</button>
                            <button onClick={decreaseZoom}>-</button>
                          </div> */}
                        </div>
                      ) : (
                        <p className="error">{error || "Loading camera…"}</p>
                      )}
                    </div>

                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => capture(webcamRef, setPhoto)}
                    >
                      📸 Take Photo
                    </button>
                  </>
                ) : (
                  <>
                    <img
                      src={photo}
                      alt="Captured"
                      className="captured-photo"
                    />

                    <div className="actions">
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={() => clearPhoto(setPhoto)}
                      >
                        🔁 Retake Photo
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="container">
            <div className="row">
              <div className="col-md-6 d-flex justify-content-start">
                <button
                  onClick={handleClear}
                  type="button"
                  className="btn btn-soft-danger rounded-pill me-3"
                >
                  <i className="ri-forbid-line me-2"></i> Clear
                </button>
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-soft-success rounded-pill"
                  disabled={loading}
                  onClick={handleSave}
                >
                  {!loading ? (
                    <>
                      <i className="ri-check-double-line me-2"></i> Save
                    </>
                  ) : (
                    <>
                      Please wait...
                      <span className="spinner-border spinner-border-sm ms-2"></span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
